<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback modal--zero-balance " id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_confirm_purchase_for_pin_oups_something }}</h1>
          <img class="oops" src="static/images/sad_face.svg" alt="">
        </div>
        <div class="modal__body">
          {{ getTranslations.home_modals_confirm_purchase_for_pin_bundles_are_currently }}
        </div>
        <div class="modal__footer">
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// modal_operator_down_PIN
export default {
  name: 'confirm-purchase-for-pin-error',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseForPinError.vue